import styled from 'styled-components'

export const FocalPointsRoot = styled.div`
  text-align: left;
  width: 100%;
`

export const FocalPointEmptyMessage = styled.p`
  font-size: 14px;
  color: #464646;
`

export const FocalPointTitle = styled.p`
  font-weight: 700;
  font-size: 14px;
  color: #464646;
  margin-bottom: 8px;
`

export const FocalPointLine = styled.p`
  font-size: 14px;
  color: #464646;
  margin-bottom: 4px;
`

export const FocalPointLinkedinLine = styled.p<{ $hasDividerBelow: boolean }>`
  font-size: 14px;
  color: #464646;
  margin-bottom: ${({ $hasDividerBelow }) => ($hasDividerBelow ? '16px' : '0')};
`

export const FocalPointDivider = styled.hr`
  border: none;
  border-top: 1px solid #d9d9d9;
  margin: 16px 0;
`
